import React from 'react';
import { Eye, Target, Compass } from 'lucide-react';

const Vision = () => {
  return (
    <div className="page-container">
      {/* Page Header */}
      <section className="page-header">
        <h1 className="page-title">Vision & Mission</h1>
        <p className="page-subtitle">
          Guiding principles that drive our organization forward
        </p>
      </section>

      {/* Vision Section */}
      <section className="vision-mission-section">
        <div className="vision-mission-card">
          <div className="vision-mission-icon">
            <Eye size={48} />
          </div>
          <h2 className="vision-mission-title">Our Vision</h2>
          <p className="vision-mission-text">
            To be the most trusted technology partner for businesses worldwide, recognized for our 
            innovation, excellence, and commitment to delivering transformative digital solutions that 
            empower organizations to achieve their full potential.
          </p>
        </div>
      </section>

      {/* Mission Section */}
      <section className="vision-mission-section">
        <div className="vision-mission-card">
          <div className="vision-mission-icon">
            <Target size={48} />
          </div>
          <h2 className="vision-mission-title">Our Mission</h2>
          <p className="vision-mission-text">
            To deliver world-class IT solutions that drive business growth and operational efficiency. 
            We are committed to:
          </p>
          <ul className="mission-list">
            <li>Providing innovative software solutions tailored to client needs</li>
            <li>Maintaining the highest standards of quality and professionalism</li>
            <li>Fostering a culture of continuous learning and innovation</li>
            <li>Building long-term partnerships based on trust and transparency</li>
            <li>Contributing to the success of our clients through cutting-edge technology</li>
          </ul>
        </div>
      </section>

      {/* Strategic Goals */}
      <section className="goals-section">
        <div className="goals-header">
          <Compass size={48} className="goals-icon" />
          <h2 className="section-title">Strategic Goals</h2>
        </div>
        <div className="goals-grid">
          <div className="goal-card">
            <h3 className="goal-title">Innovation Leadership</h3>
            <p className="goal-text">
              Stay at the forefront of emerging technologies and industry best practices to deliver 
              cutting-edge solutions.
            </p>
          </div>
          <div className="goal-card">
            <h3 className="goal-title">Client Success</h3>
            <p className="goal-text">
              Ensure every project exceeds client expectations and contributes measurably to their 
              business objectives.
            </p>
          </div>
          <div className="goal-card">
            <h3 className="goal-title">Team Excellence</h3>
            <p className="goal-text">
              Build and nurture a team of highly skilled professionals committed to continuous learning 
              and growth.
            </p>
          </div>
          <div className="goal-card">
            <h3 className="goal-title">Global Expansion</h3>
            <p className="goal-text">
              Expand our presence in key markets while maintaining our commitment to quality and 
              personalized service.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Vision;
